export default function roundCredits(credits) {
    return typeof credits === 'number' ? Math.round(credits * 10) / 10 : credits
}



// WEBPACK FOOTER //
// src/utils/roundCredits.js